import styled, { css } from 'styled-components';
import spacing from '../../styles/spacing';
import { vars } from '../../theme';
import { CSSProperties } from 'react';

export const DividerContainer = styled.div<{
    margin: string;
    $padding?: CSSProperties['padding'];
}>`
    margin: ${({ margin }) => margin};
    padding: ${({ $padding }) => $padding};
    width: 100%;
`;

export const Divider = styled.div<{
    dashed: boolean;
    color: string;
}>`
    position: relative;
    border: none;
    border-bottom: 1px;
    border-bottom-color: ${({ color }) => color};
    border-bottom-style: solid;
    height: 0;
    margin: 0;
    display: block;
    width: 100%;
    background: transparent;

    > * {
        position: absolute;
        background: ${vars.colors.surface.container};
        padding-top: 1px;
        line-height: 1;
        padding-right: ${spacing[4]};
        transform: translateY(-50%);
    }

    ${({ dashed }) =>
        dashed &&
        css`
            border-bottom-style: dashed;
        `};
`;
